import './style.css';
import '../styles/style.css';
import refs from 'bz-utilities/modules/legacy/refs';
import { observer, Provider } from 'mobx-react';
import React from 'react';
import Debugger from './debugger';
import Editor from './editor';
import Properties from './properties';
import Toolbox from './toolbox';

@observer
@refs('editor')
class Draft extends React.Component {
  onFocus() {
    this._refs.editor.current.focus();
  }

  render() {
    let { data, store } = this.props;
    let { mode, highlight } = store;

    if (!store.editor) {
      return <span />;
    }

    let cursor = highlight ? 'highlight' : '';

    return (
      <Provider draftStore={store}>
        <div className={`designer ${mode} ${cursor} ${this.props.className}`} data={data}>
          <Properties store={store} onFocus={this.onFocus.bind(this)} />
          <Toolbox store={store} onFocus={this.onFocus.bind(this)} />
          <Editor ref={this._refs.editor} store={store} />
          <Debugger store={store} />
        </div>
      </Provider>
    );
  }
}

Draft.defaultProps = {
  onFocus: () => {}
};

export default Draft;

export const { defaultProps } = Draft;
